module.exports = __webpack_public_path__ + "static/media/meeting_room_bg.7fb02dc0.jpg";